"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToAvailabilityZipFormProps({ data }) {
    let form = null;
    if (!('blockType' in data)) {
        form = data;
    }
    else if (data.availabilityZipFormReference && typeof data.availabilityZipFormReference === 'object') {
        form = data.availabilityZipFormReference;
    }
    return {
        label: form?.labelText,
        placeholderText: form?.placeholderText,
        buttonText: form?.buttonText,
        buttonColor: form?.buttonColor?.toLowerCase(),
        outlined: form?.outlined,
        formVisibility: form?.formVisibility
    };
}
exports.default = mapToAvailabilityZipFormProps;
